export enum TemplateValueTypeEnum {
    Text = 1,
    Number = 2,
    Link = 3,
    Email = 4,
    Image = 5,
}

export enum TemplateTypeEnum {
    SMS = 'SMS',
    Hoory = 'Hoory',
    Internal = 'Internal',
    Telegram = 'Telegram',
    Email = 'Email',
    PushNotification = 'PushNotification',
    // CustomerJourneyVisualization = 'CustomerJourneyVisualization',
    PopUp = 'PopUp',
    CMSPopUp = 'CMSPopUp',
    CMSBanner = 'CMSBanner',
    Viber = 'Viber',
    DynamicPopUp = 'DynamicPopUp',
    WhatsApp = 'WhatsApp',
    WhatsAppProvider = 'WhatsAppProvider',
}

export enum WhatsAppTemplateStatusEnum {
    Approved = 'APPROVED',
    Rejected = 'REJECTED',
    Pending = 'PENDING',
}

export enum WhatsAppTemplateCategoryEnum {
    Marketing = 'MARKETING',
    Utility = 'UTILITY',
}

export enum WhatsAppTemplateSubCategoryEnum {
    Custom = 'CUSTOM',
}

export enum WhatsAppTemplateParameterFormatEnum {
    Positional = 'POSITIONAL',
    Named = 'NAMED',
}

export enum WhatsAppComponentTypeEnum {
    Header = 'HEADER',
    Body = 'BODY',
    Footer = 'FOOTER',
    Buttons = 'BUTTONS',
}

export enum WhatsAppHeaderFormatEnum {
    Text = 'TEXT',
    Image = 'IMAGE',
    Video = 'VIDEO',
    Document = 'DOCUMENT',
    Location = 'LOCATION',
}

export enum WhatsAppComponentPropertyKeyEnum {
    Type = 'type',
    Format = 'format',
    Text = 'text',
    Buttons = 'buttons',
    Example = 'example',
}
